<template>
    <div class="marriage-page">
        <!-- 1. 标题部分 -->
        <div class="report-title-bar marriage-title-bar dsp-flex">
            <div class="report-title-side">
                <span class="report-title-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></span>
            </div>
            <div class="report-title-mid"><span>出生时间验证</span></div>
            <div class="report-title-side"></div>
        </div>
        <!-- 2. 内容部分 -->
        <div v-if="showType == 1" class="marriage-verify-content-box">
            <div class="marriage-verify-content">
                <div class="marriage-verify-img-box"></div>
                <div class="marriage-verify-info-box">
                    <p class="marriage-verify-info-text">在计算缘份之前请先验证生日时间的准确性，我们以性格特征为必须验证项，<span class="red">如果多数相符，说明生日信息无误，可以继续后面的测评，</span>否则建议确认好生日信息尤其是阳历和阴历是否搞反了再继续，注意生日信息以实际出生地的时间为准，不要以身份证为准，且只支持北半球出生生日哦。</p>
                </div>
                <div class="marriage-verify-button-box">
                    <button class="marriage-submit-btn marriage-verify-btn" @click="clickVerify">免费解锁</button>
                </div>
                <div class="marriage-little-bg little-bg2"></div>
            </div>
        </div>
        <!-- 3. 其他信息 -->
        <div v-else class="marriage-verify-content-box">
            <div class="marriage-verify-content marriage-verify-content2">
                <div class="marriage-verify-info-box marriage-verify-info-box-bb" v-if="marriageBaseDataOne">
                    <div class="marriage-verify-info text-center">
                        <div class="info-avatar" :class="marriageBaseDataOne.gender == 0 ? 'avatar-male' : 'avatar-female'"></div>
                        <div class="marriage-verify-info-text"><span :class="marriageBaseDataOne.gender == 0 ? 'text-male' : 'text-female'">{{ marriageBaseDataOne.name }}</span></div>
                    </div>
                    <div class="marriage-verify-info">
                        <div class="marriage-verify-info-birth">阳历{{ marriageBaseDataOne.show.yTime }}</div>
                        <div class="marriage-verify-info-birth">农历{{ marriageBaseDataOne.show.nTime }}</div>
                    </div>
                    <p class="marriage-verify-info" v-for="text in marriageBaseDataOne.show.des">{{ text }}</p>
                </div>
                <div class="marriage-verify-info-box" v-if="marriageBaseDataTwo">
                    <div class="marriage-verify-info text-center">
                        <div class="info-avatar" :class="marriageBaseDataTwo.gender == 0 ? 'avatar-male' : 'avatar-female'"></div>
                        <div class="marriage-verify-info-text"><span :class="marriageBaseDataTwo.gender == 0 ? 'text-male' : 'text-female'">{{ marriageBaseDataTwo.name }}</span></div>
                    </div>
                    <div class="marriage-verify-info">
                        <div class="marriage-verify-info-birth">阳历{{ marriageBaseDataTwo.show.yTime }}</div>
                        <div class="marriage-verify-info-birth">农历{{ marriageBaseDataTwo.show.nTime }}</div>
                    </div>
                    <p class="marriage-verify-info" v-for="text in marriageBaseDataTwo.show.des">{{ text }}</p>
                </div>
            </div>
            <div class="marriage-verify-button-box2">
                <button class="marriage-start-btn" @click="clickStart">{{ marriageData.f_type == 1 ? '开始计算个人姻缘' : '开始计算二人缘分' }}</button>
                <div class="marriage-verify-button-text">{{ marriageData.f_type == 1 ? '建议确认性格基本都能对上才开始计算，否则需确认生日时间的准确性' : '建议确认双方性格基本都能对上才开始计算，否则需确认生日时间的准确性' }}</div>
            </div>

        </div>

        <div class="marriage-bottom-bg"></div>
    </div>
</template>

<script>
import { MIX, UTILS, UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
export default {
    name: 'MarriageVerify',
    components: {  },
    computed: {
        marriageData() {
            return this.$store.state.marriage.marriageData;
        },
        marriageBaseDataOne() {
            return this.$store.state.marriage.marriageBaseDataOne;
        },
        marriageBaseDataTwo() {
            return this.$store.state.marriage.marriageBaseDataTwo;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            showType: 1,
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif'),
        }
    },
    mounted() {
        setTimeout(() => {
            window.scrollTo(0, 0);
            if(!this.marriageData.id) {
                this.$router.replace({ path: '/marriagerecord' });
                return;
            }
        }, 20);
    },
    methods: {
        clickBack() {
            this.$store.dispatch('marriage/resetMarriageData');
            this.$router.replace({ path: '/marriagerecord' });
        },
        clickVerify() {
            if(!this.marriageData.id) {
                return;
            }
            this.$store.dispatch('marriage/setMarriageVerifyData', {
                sucCb: () => {
                    this.showType = 2;
                }
            });
        },
        clickPayPop() {
            this.showPaySuc = false;
        },
        clickStart() {
            this.$router.replace({ path: '/marriagegenerate' });
        }
    }
}
</script>